export default __webpack_public_path__ + "static/media/TitilliumWeb-LightItalic.84fb8b10.ttf";